import React from 'react';
import { Helmet } from 'react-helmet';

export default function WordCharCounterGuide() {
  return (
    <main className="container mx-auto px-4 py-12">
      <Helmet>
        <title>How to Count Words & Characters for SEO & Writing | WebUtility</title>
        <meta name="description" content="Learn how to use a word and character counter tool to optimize your content for SEO and writing limits." />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">How to Count Words & Characters for SEO & Writing</h1>
      <p className="mb-4 text-gray-600">
        Knowing the word and character count is essential for SEO, academic writing, and social media. Our tool makes it easy!
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Why Word Count Matters?</h2>
      <ul className="list-disc ml-6">
        <li><strong>SEO:</strong> Aim for at least 300+ words for blog posts.</li>
        <li><strong>Twitter:</strong> Stay within 280 characters.</li>
        <li><strong>Essays:</strong> Meet specific word limits to avoid penalties.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Steps to Use the Tool</h2>
      <ol className="list-decimal ml-6">
        <li>Open our <a href="/texttools" className="text-blue-600 underline">Word Counter Tool</a>.</li>
        <li>Paste your text.</li>
        <li>See real-time word & character count updates.</li>
      </ol>
    </main>
  );
}
